import React from 'react';
import { Box, Card, Group, Stack, Text, rem } from '@mantine/core';
import { motion } from 'framer-motion';
import ShellLogo from '@/components/appshell/Shell.Logo';
import AuthAside from '@/components/auth/frame/components/Auth.Aside';
import { AUTH_COPY } from '@/components/auth/frame/config/auth.labels';
import { FADE_UP, STAGGER } from '@/theme/motion';

type Props = {
    title: string;
    subtitle: React.ReactNode;
    icon?: React.ReactNode;
    aside?: React.ReactNode;
    children: React.ReactNode;
};

const AuthFrame: React.FC<Props> = ({ title, subtitle, icon, aside, children }) => (
    <Box className="bd-login-grid" style={{ minHeight: '100dvh', display: 'grid', backgroundColor: 'var(--bd-shell)' }}>
        <AuthAside />

        <Box
            style={{
                display: 'grid',
                placeItems: 'center',
                padding: 'max(clamp(1rem, 4vw, 2.5rem), env(safe-area-inset-top, 0px)) clamp(1rem, 4vw, 2.5rem) max(clamp(1rem, 4vw, 2.5rem), env(safe-area-inset-bottom, 0px))',
            }}
        >
            <Card
                radius="lg"
                padding="clamp(1rem, 3vw, 2rem)"
                withBorder
                style={{ width: '100%', maxWidth: '26rem', backgroundColor: 'var(--bd-surface)' }}
            >
                <motion.div variants={STAGGER} initial="hidden" animate="visible">
                    <Stack gap="lg">
                        <Box hiddenFrom="md">
                            <ShellLogo />
                        </Box>

                        <motion.div variants={FADE_UP}>
                            <Group gap="sm" wrap="nowrap" align="flex-start">
                                {icon ? (
                                    <Box
                                        aria-hidden
                                        style={{
                                            display: 'grid', placeItems: 'center', flexShrink: 0,
                                            width: rem(40), height: rem(40), borderRadius: 'var(--mantine-radius-md)',
                                            backgroundColor: 'var(--bd-brand-soft)', color: 'var(--bd-brand-text)',
                                        }}
                                    >
                                        {icon}
                                    </Box>
                                ) : null}
                                <Stack gap={4} style={{ minWidth: 0, flex: 1 }}>
                                    <Group justify="space-between" gap="xs" wrap="nowrap" align="baseline">
                                        <Text component="h1" fz="xl" fw={800} m={0} style={{ letterSpacing: '-0.02em', color: 'var(--bd-text-strong)' }}>
                                            {title}
                                        </Text>
                                        {aside}
                                    </Group>
                                    <Text fz="sm" c="dimmed" lh={1.55}>{subtitle}</Text>
                                </Stack>
                            </Group>
                        </motion.div>

                        <motion.div variants={FADE_UP}>{children}</motion.div>

                        <Text fz="xs" c="dimmed" ta="center" hiddenFrom="md">{AUTH_COPY.identityNote}</Text>
                    </Stack>
                </motion.div>
            </Card>
        </Box>
    </Box>
);

export default AuthFrame;
